/** Element `id` on the footer block with App Store / Google Play badges. */
export const FOOTER_APP_STORES_ID = 'footer-app-stores';

/** Same-page link for CTAs that should scroll to store badges. */
export const FOOTER_APP_STORES_HREF = `#${FOOTER_APP_STORES_ID}`;

/** Element `id` on the footer newsletter subscribe block. */
export const FOOTER_SUBSCRIBE_ID = 'subscribe';

/** Same-page link for CTAs that should scroll to the newsletter subscribe form. */
export const FOOTER_SUBSCRIBE_HREF = `#${FOOTER_SUBSCRIBE_ID}`;
